import Axios from 'axios';
import CryptoJS from 'crypto-js';

const API_BASE_URL = '/api';

const generateSign = (queries = {}) => {
  if (process.env.NODE_ENV === 'test') {
    return 'mock-sign';
  }
  const secret = process.env.SIGN_SECRET;
  const arr = Object.entries(queries).map(([key, val]) => `${key}=${val}`);
  return CryptoJS.HmacMD5(arr.sort().join('&'), secret).toString();
};

export const api = Axios.create({
  // baseURL: API_BASE_URL,
  baseURL: typeof window !== 'undefined' ? API_BASE_URL : `${process.env.SITE_ORIGIN}${API_BASE_URL}`,
});

export const apiNew = (url)=> {
  const axiosInstance = Axios.create({
    baseURL: typeof window !== 'undefined' ? API_BASE_URL : url,
  });

  axiosInstance.interceptors.request.use((config) => ({
    ...config,
    params: {
      ...formatedCommonParams,
      ...removeBlankParam(config.params),
      sign: generateSign({
        ...formatedCommonParams,
        ...removeBlankParam(config.params),
      }),
    },
  }));

  return axiosInstance;
};

export const commonParams = {
    lang: 'zh-Hans',
    platform: 'light',
    app_id: 'light',
    terminal: 'web',
    timestamp: new Date().getTime(),
    device: 'mobile',
  };

export const removeBlankParam = (params) => {
  try {
    const rtv = {};
    Object.keys(params).forEach((key) => {
      if (typeof params[key] !== 'undefined' && params[key] !== '') {
        rtv[key] = params[key];
      }
    });
    return rtv;
  } catch (e) {
    return params;
  }
};

export const formatedCommonParams = removeBlankParam(commonParams);

api.interceptors.request.use((config) => ({ // NOSONAR
  ...config,
  params: {
    ...formatedCommonParams,
    ...removeBlankParam(config.params),
    sign: generateSign({
      ...formatedCommonParams,
      ...removeBlankParam(config.params),
    }),
  },
}));

export const getHeaders = csrfToken => (
  {
    'X-CSRF-Token': csrfToken,
  }
);
